import styled, { css } from 'styled-components';

export const Label = styled.label`
  flex-shrink: 0;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: 15px;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  letter-spacing: 0.16px;

  ${({ isRequired }) =>
    isRequired &&
    css`
      padding-left: 10px;
      &:before {
        content: '*';
        display: inline-block;
        width: 11px;
        margin-left: -11px;
        color: ${({ theme }) => theme.defaultColors.error};
      }
    `}
`;
